import {Injectable} from '@angular/core';
import {AuthService} from '../../core/security/auth.service';
import {PublicService} from '../../api/services/public.service';
import {BusinessReferralModel} from '../../api/models/business-referral-model';

@Injectable()
export class ReferralService {

  constructor(private authService: AuthService, private publicService: PublicService) {

  }

  async sendBusinessReferralEmail(model: BusinessReferralModel): Promise<boolean> {
    await this.publicService.publicSendBusinessReferral({body: model}).toPromise();
    return true;
  }
}
